<p-dialog #dialog [(visible)]="mostrarModal" [draggable]="false" [resizable]="false" [modal]="true"
  (onHide)="cerrarModal()" [dismissableMask]="true" class="z-modal w-700">
  <ng-template pTemplate="header">
    <h2 class="z-titulo z-center">
      <strong>{{tituloModal}}</strong>
    </h2>
  </ng-template>
  <ng-template pTemplate="content">
    <div style="padding-top: 33px;" [innerHTML]="cuerpoTexto">
    </div>

    <div *ngIf="mostrarCheckBox" class="z-bloque background gris" style="width: 100%; margin-bottom: 20px;">
      <div class="z-forms" style="margin: 0">
        <p-checkbox class="justify-label" [binary]="true" (onChange)="onChangeCheckTerminos()"
          [(ngModel)]="checkAceptaTerminos" [label]="textoCheckbox"></p-checkbox>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <div class="d-flex justify-content-center flex-column align-items-center">
      <button [disabled]="!habilitarAceptar" (click)="aceptarTerminos()"
        class="z-btn z-btn-primary mb-4">{{btnText}}</button>
      <a *ngIf="mostrarBtnVolver" (click)="cerrarModal()" href="javascript:void(0)"
        class="z-btn z-btn-link pb-4">Volver</a>
    </div>
  </ng-template>
</p-dialog>